import type { WidgetType } from "constants/WidgetConstants";
import React from "react";
import type { WidgetProps } from "widgets/BaseWidget";
import ContainerWidget from "../../../widgets/ContainerWidget";
import type {ContainerWidgetProps} from "../../../widgets/ContainerWidget/widget";
import {ValidationTypes} from "../../../constants/WidgetValidation";
import {EvaluationSubstitutionType} from "../../../entities/DataTree/types";
import {PropertyPaneConfig} from "../../../constants/PropertyControlConstants";
import AmapComponent from "widgetsExtend/AmapViewWidget/component";

class AmapContainerWidget extends ContainerWidget {
  constructor(props: AmapWidgetProps) {
    super(props);
  }
  static getPropertyPaneEventConfig(): PropertyPaneConfig[] {
    return super.getWidgetEvents('AmapViewWidget');
  }
  static getPropertyPaneContentConfig() {
    return [
      {
        sectionName: "标签",
        children: [
          {
            helpText: "Sets the label text of the widget",
            propertyName: "labelText",
            label: "文本",
            controlType: "INPUT_TEXT",
            placeholderText: "Enter label text",
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          }
        ]
      },
      {
        sectionName: '数据',
        children: [
          {
            helpText: "Bind data from an API using {{}}",
            propertyName: "currentData",
            label: "Data",
            controlType: "INPUT_TEXT",
            placeholderText: '[]',
            inputType: "ARRAY",
            isBindProperty: true,
            isTriggerProperty: false,
            validation: {
              type: ValidationTypes.OBJECT_ARRAY,
              params: {
                default: [],
              },
            },
            evaluationSubstitutionType: EvaluationSubstitutionType.SMART_SUBSTITUTE,
          }

        ]
      },
      {
        sectionName: '中心点',
        children: [
          {
            helpText: "Bind data from an API using {{}}",
            propertyName: "centerLnglat",
            label: "经纬度",
            controlType: "INPUT_TEXT",
            placeholderText: '[114.30409, 30.586378]',
            inputType: "ARRAY",
            isBindProperty: true,
            isTriggerProperty: false,
            validation: {
              type: ValidationTypes.ARRAY,
              params: {
                default: [],
              },
            },
          }
        ]
      },
      {
        sectionName: "设置",
        children: [
          {
            propertyName: "dragEnable",
            label: "支持拖动地图",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            propertyName: "zoomEnable",
            label: "支持缩放地图",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            propertyName: "isSearch",
            label: "允许搜索",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            propertyName: "isShowCard",
            label: "点击标记点打开记录详情卡片",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            propertyName: "zoomLevel",
            label: "默认地图层级",
            controlType: "NUMERIC_INPUT",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            min: 3,
            max: 20,
            validation: {
              type: ValidationTypes.NUMBER,
              params: {
                natural: true,
              },
            }
          },
          {
            propertyName: "rotation",
            label: "默认地图旋转角度",
            controlType: "NUMERIC_INPUT",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            defaultValue: 0,
            min: 0,
            max: 360,
            validation: {
              type: ValidationTypes.NUMBER,
              params: {
                natural: true,
              },
            }
          },
          {
            helpText: "Sets the label position of the widget",
            propertyName: "viewMode",
            label: "地图模式",
            controlType: "ICON_TABS",
            fullWidth: true,
            options: [
              { label: "2D", value: "2D" },
              { label: "3D", value: "3D" },

            ],
            defaultValue: "2D",
            isBindProperty: true,
            isTriggerProperty: true,
            validation: { type: ValidationTypes.TEXT },
          },
          {
            propertyName: "pitch",
            label: "倾斜度",
            controlType: "NUMERIC_INPUT",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            min: 0,
            max: 360,
            hidden: (props: any) => props.viewMode == "2D",
            validation: {
              type: ValidationTypes.NUMBER,
              params: {
                natural: true,
              },
            }
          },
          {
            propertyName: "mapStyle",
            label: "地图风格",
            controlType: "DROP_DOWN",
            fullWidth: true,
            options: [
              { label: "标准样式", value: 'amap://styles/normal' },
              { label: "清新蓝", value: 'amap://styles/blue' },
              { label: "黑夜风格", value: 'amap://styles/dark' },
              { label: "月光银", value: 'amap://styles/light' },
              { label: "无底图", value: 'amap://styles/blank' },
              { label: "卫星影像", value: 'amap://styles/satellite'},
            ],
            defaultValue: "amap://styles/normal",
            isBindProperty: true,
            isTriggerProperty: true,
            validation: { type: ValidationTypes.TEXT },
          },
          {
            propertyName: "features",
            label: "显示内容",
            controlType: "INPUT_TEXT",
            placeholderText: '["bg", "road", "building","point"]',
            inputType: "ARRAY",
            isBindProperty: true,
            isTriggerProperty: true,
            validation: {
              type: ValidationTypes.ARRAY,
              params: {
                default: [],
              },
            },
          }
        ]
      },
      {
        sectionName: "地图API设置",
        children: [
          {
            propertyName: "securityJsKey",
            label: "key",
            controlType: "INPUT_TEXT",
            placeholderText: "Enter label text",
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
          {
            propertyName: "securityJsCode",
            label: "安全密钥",
            controlType: "INPUT_TEXT",
            placeholderText: "Enter label text",
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
        ]
      },
      {
        sectionName: "一般",
        children: [
          {
            helpText: "Controls the visibility of the widget",
            propertyName: "isVisible",
            label: "是否可见",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          }
        ],
      }
    ];
  }
  static getPropertyPaneStyleConfig() {
    return [
      {
        sectionName: "颜色",
        children: [

          {
            propertyName: "borderColor",
            label: "边框颜色",
            helpText: "Control the color of the label associated",
            controlType: "COLOR_PICKER",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
        ],
      },
      {
        sectionName: "边框&阴影",
        children: [
          {

            propertyName: "borderWidth",
            label: "边框宽度",
            controlType: "NUMERIC_INPUT",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            min: 0,
            max:10,
            defaultValue: 1,
            validation: {
              type: ValidationTypes.NUMBER,
              params: {
                natural: true,
              },
            },
          },
          {
            propertyName: "borderRadius",
            label: "边框圆角",
            helpText: "Rounds the corners of the icon button's outer border edge",
            controlType: "BORDER_RADIUS_OPTIONS",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
          {
            propertyName: "boxShadow",
            label: "阴影",
            helpText:
              "Enables you to cast a drop shadow from the frame of the widget",
            controlType: "BOX_SHADOW_OPTIONS",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
        ],
      },
    ];
  }
  static getPropertyPaneStyleConfig() {
    return [
      {
        sectionName: "颜色",
        children: [

          {
            propertyName: "borderColor",
            label: "边框颜色",
            helpText: "Control the color of the label associated",
            controlType: "COLOR_PICKER",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
        ],
      },
      {
        sectionName: "边框&阴影",
        children: [
          {

            propertyName: "borderWidth",
            label: "边框宽度",
            controlType: "NUMERIC_INPUT",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            min: 0,
            max:10,
            defaultValue: 1,
            validation: {
              type: ValidationTypes.NUMBER,
              params: {
                natural: true,
              },
            },
          },
          {
            propertyName: "borderRadius",
            label: "边框圆角",
            helpText: "Rounds the corners of the icon button's outer border edge",
            controlType: "BORDER_RADIUS_OPTIONS",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
          {
            propertyName: "boxShadow",
            label: "阴影",
            helpText:
              "Enables you to cast a drop shadow from the frame of the widget",
            controlType: "BOX_SHADOW_OPTIONS",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
        ],
      },
    ];
  }
  renderAsContainerComponent(props: ContainerWidgetProps<WidgetProps>) {
    return (
      <>
        <div style={{width: '100%', height: '100%', position: 'absolute', zIndex: 1}}>
          <AmapComponent  {...props} />
        </div>
        <>{this.renderChildren()}</>
      </>
    );
  }
  static getWidgetType(): WidgetType {
    return "AMAP_CONTAINER_WIDGET";
  }
}

export interface AmapWidgetProps extends WidgetProps {
  isLast: boolean,
  isSearch: boolean,
  isMultiple: boolean
}

export default AmapContainerWidget;
